export const OPEN_MODAL_COMMENTS_TAB = 'OPEN_MODAL_COMMENTS_TAB';
export const OPEN_MODAL_KUDOS_TAB = 'OPEN_MODAL_KUDOS_TAB';
export const OPEN_MODAL_ACHIEVEMENTS_TAB = 'OPEN_MODAL_ACHIEVEMENTS_TAB';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_KUDO_STATUS = 'UPDATE_KUDO_STATUS';
export const KUDO_STATUS_UPDATE_COMPLETED = 'KUDO_STATUS_UPDATE_COMPLETED';
export const COMMENT_SUBMITTED = 'COMMENT_SUBMITTED';

export default {
  OPEN_MODAL_COMMENTS_TAB,
  OPEN_MODAL_KUDOS_TAB,
  OPEN_MODAL_ACHIEVEMENTS_TAB,
  CLOSE_MODAL,
  UPDATE_KUDO_STATUS,
  KUDO_STATUS_UPDATE_COMPLETED,
  COMMENT_SUBMITTED
};
